'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React from 'react';

import cx from 'clsx';

import { BLOCKS } from '@contentful/rich-text-types';

import Img from 'components/ui/Img';
import RichText from 'components/ui/RichText';
import Text from 'components/ui/Text';

import { getColor } from 'utils';

import styles from './TalesFanStoryCard.module.scss';

const richTextOverrides = {
    Display: {
        renderNode: {
            [BLOCKS.PARAGRAPH]: (node, children) => (
                <Text
                    as="p"
                    className={cx(styles.copy, styles.display)}
                    baseTheme="displaySmall"
                    themes={{
                        medium: 'displayMedium',
                    }}
                >
                    {children}
                </Text>
            ),
        },
    },
    Body: {
        renderNode: {
            [BLOCKS.PARAGRAPH]: (node, children) => (
                <Text
                    as="p"
                    className={styles.copy}
                    baseTheme="bodyMedium"
                    themes={{
                        medium: 'bodyMedium',
                        large: 'bodyMediumLarge',
                    }}
                >
                    {children}
                </Text>
            ),
        },
    },
};

const TalesFanStoryCard = ({
    order,
    bodyCopy,
    bodyCopyFont,
    label,
    image,
    backgroundColor,
    isInView,
}) => {
    return (
        <article
            className={cx(styles.root, {
                [styles.isInView]: isInView,
            })}
            style={{
                backgroundColor: backgroundColor
                    ? getColor(backgroundColor)
                    : 'var(--colors-cream)',
                '--delay': `${order * 0.1}s`,
            }}
        >
            {image?.url && (
                <div className={styles.media}>
                    <Img
                        className={styles.image}
                        src={image.url}
                        width={image?.width}
                        height={image?.height}
                        fallbackImageWidth={768}
                        alt={image.description}
                        customSources={[
                            {
                                breakpoint: 768,
                                src: image.url,
                                imageWidth: 1280,
                            },
                            {
                                src: image.url,
                                imageWidth: 768,
                            },
                        ]}
                    />
                </div>
            )}
            <div className={styles.body}>
                {bodyCopy && (
                    <RichText
                        richText={bodyCopy}
                        overrides={richTextOverrides[bodyCopyFont]}
                    />
                )}
                {label && (
                    <Text
                        className={styles.label}
                        baseTheme="labelSmall"
                        themes={{
                            medium: 'labelMedium',
                            large: 'labelLarge',
                        }}
                    >
                        {label}
                    </Text>
                )}
            </div>
        </article>
    );
};

export default TalesFanStoryCard;
